export default __webpack_public_path__ + "static/media/Furious Spirit.8eb64db7.jpg";